import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/_services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ecommerce-layout',
  templateUrl: './ecommerce-layout.component.html',
  styleUrls: ['./ecommerce-layout.component.css']
})
export class EcommerceLayoutComponent implements OnInit {

  headerColor = 'primary';
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches));
  ecomNavItems = [];
  constructor(public authService : AuthService,     
    private breakpointObserver: BreakpointObserver,
    private router:Router,
    ) { }

  ngOnInit() {
    this.ecomNavItems = [
      // {
      //   displayName: 'Ecommerce',
      //   iconName: 'local_mall',
      //   route: '/ecom',
      // },
      {
        displayName: 'Orders',
        iconName: 'add_shopping_cart',
        children: [
          {
            displayName: 'Order List',
            iconName: 'star_rate',
            route: '/ecom/orders'
          },
          {
            displayName: 'Process Orders',
            iconName: 'star_rate',
            route: '/ecom/process-orders'
          },
          // {
          //   displayName: 'Order Tracking',
          //   iconName: 'star_rate',
          //   route: '/ecom/order-tracking'
          // },
          {
            displayName: 'Assigned Orders',
            iconName: 'star_rate',
            route: '/ecom/order-assigned-for-delivery'
          },
          {
            displayName: 'Shipped Orders',
            iconName: 'star_rate',
            route: '/ecom/shipped-orders'
          },
          // {
          //   displayName: 'Generate Bill',
          //   iconName: 'star_rate',
          //   route: '/ecom/generate-bill'
          // },
          // {
          //   displayName: 'Delivery Process',
          //   iconName: 'star_rate',
          //   route: '/ecom/delivery-process'
          // },
          {
            displayName: 'Return Orders',
            iconName: 'star_rate',
            route: '/ecom/return-orders'
          },


          
        ]
      },
      {
        displayName: 'Products',
        iconName: 'local_grocery_store',
        children: [
          {
            displayName: 'All Products',
            iconName: 'star_rate',
            route: '/ecom/products'
          },
          {
            displayName: 'Add Product',
            iconName: 'star_rate',
            route: '/ecom/add-product'
          },
          {
            displayName: 'Categories',
            iconName: 'star_rate',
            route: '/ecom/categories'
          },
          {
            displayName: 'Brands',
            iconName: 'branding_watermark',
            route: '/ecom/brands'
          },
          {
            displayName: 'Sizes',
            iconName: 'photo_size_select_actual',
            route: '/ecom/sizes'
          },
          {
            displayName: 'Colors',
            iconName: 'color_lens',
            route: '/ecom/colors'
          },
          // {
          //   displayName: 'Attributes',
          //   iconName: 'star_rate',
          //   route: '/ecom/attributes',
          // },
        ]
      },
      {
        displayName: 'Coupons',
        iconName: 'table_chart',
        route: '/ecom/coupons',
      },
      {
        displayName: 'Customers',
        iconName: 'supervisor_account',
        route: '/ecom/customers'
      },
      {
        displayName: 'Pages',
        iconName: 'description',
        route: '/ecom/pages'
      },
      {
        displayName: 'CMS',
        iconName: 'folder_open',
        children: [
          {
            displayName: 'Global Content',
            iconName: 'star_rate',
            route: '/ecom/global-content'
          },
          {
            displayName: 'Bannars',
            iconName: 'star_rate',
            route: '/ecom/bannars'
          },          
        ]
      },
      // {
      //   displayName: 'Outlets',
      //   iconName: 'store',
      //   route: '/ecom/outlets'
      // }
    ];
  }

  onOpenModule()
  {
    if((this.authService.user_dept=='school' || this.authService.user_dept=='admin'))
    { 
      this.router.navigateByUrl('/');
    }    
  }


  goToMyAccount(){
    this.router.navigateByUrl('/ecom/my-account');
  }

}
